/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './subgroups.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/admin/subgroups/subgroups.component';
const styles_SubgroupsComponent:any[] = [i0.styles];
export const RenderType_SubgroupsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SubgroupsComponent,data:{}});
export function View_SubgroupsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_SubgroupsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-subgroups',
      ([] as any[]),(null as any),(null as any),(null as any),View_SubgroupsComponent_0,
      RenderType_SubgroupsComponent)),i1.ɵdid(1,114688,(null as any),0,i3.SubgroupsComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SubgroupsComponentNgFactory:i1.ComponentFactory<i3.SubgroupsComponent> = i1.ɵccf('app-subgroups',
    i3.SubgroupsComponent,View_SubgroupsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9zdWJncm91cHMvc3ViZ3JvdXBzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvYWRtaW4vc3ViZ3JvdXBzL3N1Ymdyb3Vwcy5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvYWRtaW4vc3ViZ3JvdXBzL3N1Ymdyb3Vwcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9zdWJncm91cHMvc3ViZ3JvdXBzLmNvbXBvbmVudC50cy5TdWJncm91cHNDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1zdWJncm91cHM+PC9hcHAtc3ViZ3JvdXBzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/subgroups/subgroups.component.ngfactory.ts